var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2MenuCategoryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 26.2208C18.3063 26.2208 17.7726 25.9087 17.4302 25.2844C17.0878 24.6601 17.0979 24.0459 17.4604 23.4417L27.55 7.31043C27.8722 6.74654 28.3757 6.4646 29.0604 6.4646C29.7451 6.4646 30.2486 6.74654 30.5708 7.31043L40.6604 23.4417C41.0229 24.0459 41.033 24.6601 40.6906 25.2844C40.3483 25.9087 39.8146 26.2208 39.0896 26.2208H19.0312ZM42.6542 53.1667C39.6736 53.1667 37.1764 52.1597 35.1625 50.1459C33.1486 48.132 32.1417 45.6347 32.1417 42.6542C32.1417 39.6736 33.1486 37.1764 35.1625 35.1625C37.1764 33.1486 39.6736 32.1417 42.6542 32.1417C45.6347 32.1417 48.1319 33.1486 50.1458 35.1625C52.1597 37.1764 53.1667 39.6736 53.1667 42.6542C53.1667 45.6347 52.1597 48.132 50.1458 50.1459C48.1319 52.1597 45.6347 53.1667 42.6542 53.1667ZM9.0625 51.6563C8.53889 51.6563 8.1059 51.4851 7.76354 51.1427C7.42118 50.8004 7.25 50.3674 7.25 49.8438V35.1021C7.25 34.5785 7.42118 34.1455 7.76354 33.8031C8.1059 33.4608 8.53889 33.2896 9.0625 33.2896H23.8042C24.3278 33.2896 24.7608 33.4608 25.1031 33.8031C25.4455 34.1455 25.6167 34.5785 25.6167 35.1021V49.8438C25.6167 50.3674 25.4455 50.8004 25.1031 51.1427C24.7608 51.4851 24.3278 51.6563 23.8042 51.6563H9.0625Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2MenuCategoryWhite);
export default __webpack_public_path__ + "static/media/v2-menu-category-white.3f244d8757aed5218b2a1b922f9424e6.svg";
export { ForwardRef as ReactComponent };